export default __webpack_public_path__ + "4fbd51ff155a4b15d7d5556b2fe80823.svg";